import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const TrioPelletDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}><span className={styles.highlight}>TRIO Pellet</span></p>
      <p className={styles.text}>
        Cazanele pe peleți TRIO Pellet sunt prevazute pentru încălzirea locuințelor și unităților industriale în modul automat. Peleții sunt transportați cu ajutorul șnecului din buncăr, care se afla lângă cazan.
      </p>
      <p className={styles.text}>
        Combustibilul principal pentru aceasta centralа TRIO Pellet se constituie combustibil fracționar ( maxim de 25 mm), peleți din lemn și agro peleți (paie, coji de floarea soarelui, stuf, semințe s.a.)
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-triangle-exclamation" />
          <p>
            Perfectă lui exploatare cu sistem alimentare șnec depinde de corectă lui instalare,
            folosirea combustibilului potrivit și curățarea să în timp util.
          </p>
        </div>
      </div>
      <h1 className={styles.title}>Caracteristici</h1>
      <p className={styles.text}>
        Cazanul  TRIO Pellet este un cazan cu temperaturi joase și sistem automat de alimentare cu combustibil în camera de ardere.


      </p>
      <p className={styles.text}>
        Cazanul TRIO Pellet are un arzător de retorta polonez, care este automatizat și controlat de un controler atașat acestuia.Eficienta cazanului este de un minim de 91%. Este extrem de eficient și sigur.
      </p>
      <p className={styles.text}>
        Construcția acestui arzător este foarte simpla. In partea orizontala a arzătorului avem șnecul de alimentare care leagă buncărul cu peleți și partea capătului de ardere. Capăt care se termina cu un arzător de retorta rotativ.
      </p>
      <p className={styles.text}>
        Motorul-reductor de proveniența germana, al companiei  ”Nord”, care garantează o rezistenta ridicata, precum și o funcționare silențioasă, cu lunga durata de viata.
      </p>
      <p className={styles.text}>
        Este important sa setam corect pe controler regimul exact de alimentare a combustibilului, cu pauzele prestabilite, astfel încât sa nu conducă la risipirea combustibilului nears integral, sau realocarea zonei de combustie în șnecul de alimentare. In astfel de cazuri este prevazut un sistem de stingere al incendiilor, în care apa intra în șnecul de alimentare, astfel stingând focul pătruns.
      </p>
      <p className={styles.text}>
        Gazele arse ies în coșul de fum prin gaura de evacuare amplasata în partea superioara din spatele cazanului. Gura de evacuare a gazelor este echipata cu un șubler ce permite în cazul pierderii masive a căldurii prin cos, blocarea parțiala a evacuării acesteia
      </p>
      <p className={styles.text}>
        Întreținerea funcționalității cazanului consta în adăugarea periodica a combustibilului în buncăr și îndepărtarea cenușii de pe raftul cenușar al cazanului, fără a fi necesara stingerea acestuia. După aprinderea centralei nu este nevoie de o supraveghere permanenta a acestuia. Funcționalitatea cazanului poate a dura pentru întregul sezon de încălzire fără a fi întrerupta. Centrala de asemenea poate fi folosita și în afara sezonului rece, pentru încălzirea apei, legata în sistem cu un boiler.
      </p>
      <p className={styles.text}>
        Numai pe cazanele TRIO Pellet de la 400 pana la 600 кw  sunt instalate doua arzătoare cu retorta cu doua bancare pentru combustibil. Pe partea lateral opusa celei pe care sunt montate buncărele de combustibil, sunt amplasate doua rânduri de uși. Ușile din rândul superior sunt proiectate pentru aprindere,pentru a gestiona și monitoriza procesul de ardere combustibilului în retorta. Ușile din rândul inferior - pentru curățarea cenușii din partea de jos a cazanului și a retortelor.
      </p>
      <p className={styles.text}>
        Cazanul pe peleți ALTEP TRIO Pellet de la  150 кw pana la 300 кw au gura de evacuare de forma pătrata, de la 400 кw la 600 кw - rotunda. In gura de evacuare avem un șubler, cu ajutorul căruia controlam tirajul de evacuare a gazelor arse,pentru economisirea combustibilului.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th>150 kW</th>
              <th>200 kW</th>
              <th>250 kW</th>
              <th>300 kW</th>
              <th>400 kW</th>
              <th>500 kW</th>
              <th>600 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Suprafața schimbătorului de căldura</td>
              <td>m²</td>
              <td>13,1</td>
              <td>16,5</td>
              <td>24,1</td>
              <td>27,2</td>
              <td>36</td>
              <td>41,0</td>
              <td>46,2</td>
            </tr>
            <tr>
              <td>Eficiența, min</td>
              <td>%</td>
              <td colSpan="7">91</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>l</td>
              <td>365</td>
              <td>425</td>
              <td>585</td>
              <td>655</td>
              <td>800</td>
              <td>900</td>
              <td>1050</td>
            </tr>
            <tr>
              <td>Greutatea cazanului fără apa</td>
              <td>kg</td>
              <td>1500</td>
              <td>1850</td>
              <td>2300</td>
              <td>2550</td>
              <td>3800</td>
              <td>4500</td>
              <td>5000</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse</td>
              <td>°C</td>
              <td colSpan="7">100-180</td>
            </tr>
            <tr>
              <td>Temperatura apei minim recomandata</td>
              <td>°C</td>
              <td colSpan="7">58</td>
            </tr>
            <tr>
              <td>Temperatura maxima a apei</td>
              <td>°C</td>
              <td colSpan="7">85</td>
            </tr>
            <tr>
              <td>Presiunea nominala a apei (maxim)</td>
              <td>mPa</td>
              <td colSpan="7">0,20</td>
            </tr>
            <tr>
              <td>Consum de energie electrica, min</td>
              <td>W</td>
              <td>430</td>
              <td>500</td>
              <td>500</td>
              <td>500</td>
              <td>1320</td>
              <td>1320</td>
              <td>1320</td>
            </tr>
            <tr>
              <td>Diametru etern racord cos</td>
              <td>mm</td>
              <td>298</td>
              <td>348</td>
              <td>398</td>
              <td>448</td>
              <td>498</td>
              <td>548</td>
              <td>548</td>
            </tr>
            <tr>
              <td>Diametru conexiune rețelei de apa (Du)</td>
              <td>mm</td>
              <td>80(FL)</td>
              <td>80(FL)</td>
              <td>100(FL)</td>
              <td>100(FL)</td>
              <td>100(FL)</td>
              <td>125(FL)</td>
              <td>125(FL)</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="9">Dimensiuni burlan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>660</td>
              <td>908</td>
              <td>1194</td>
              <td>1520</td>
              <td>1885</td>
              <td>2290</td>
              <td>2290</td>
            </tr>
            <tr>
              <td>Diametru intern</td>
              <td>mm</td>
              <td>300</td>
              <td>350</td>
              <td>400</td>
              <td>450</td>
              <td>500</td>
              <td>550</td>
              <td>550</td>
            </tr>
            <tr>
              <td>Înălțime (min permisă)</td>
              <td>m</td>
              <td>10</td>
              <td>11</td>
              <td>11</td>
              <td>12</td>
              <td>13</td>
              <td>14</td>
              <td>15</td>
            </tr>
            <tr>
              <td>Putere ventilator</td>
              <td>m³/ora</td>
              <td>600</td>
              <td>600</td>
              <td>600</td>
              <td>600×2</td>
              <td>600×2</td>
              <td>600×2</td>
              <td>600×2</td>
            </tr>
            <tr>
              <td>Diametru țevii de sub siguranțele supapei (Du)</td>
              <td>mm</td>
              <td>50(FL)</td>
              <td>50(FL)</td>
              <td>50(FL)</td>
              <td>50×2(FL)</td>
              <td>50×2(FL)</td>
              <td>50×2(FL)</td>
              <td>50×2(FL)</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div >
  );
};

export const TrioPelletDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [1750, 2710, 3170, 3410, 2650, 2650, 2750] },
    { param: "B1", unit: "mm", values: [970, 1380, 1380, 1380, 1480, 1480, 1530] },
    { param: "H", unit: "mm", values: [1660, 1760, 1760, 1860, 1860, 1960, 1960] },
    { param: "H1", unit: "mm", values: [1540, 1640, 1640, 1740, 1740, 1850, 1850] },
    { param: "H2", unit: "mm", values: [1266, 1316, 1288, 1364, 1340, 1415, 1415] },
    { param: "L", unit: "mm", values: [2100, 2110, 2300, 2380, 3310, 3350, 3650] },
    { param: "L1", unit: "mm", values: [1800, 1800, 2000, 2080, 2890, 2930, 3120] }
  ]


  const headers = ["Parametri", "U.M.", "150 kW", "200 kW", "250 kW", "300 kW", "400 kW", "500 kW", "600 kW"]

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/TrioPelletSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};